<template>
  <div class="px-8 py-6" style="height:100dvh; width:100%;overflow-y: auto;">
    <h3>입고 현황</h3>
    <FilterModal
      :filterList="filterList"
      :listItems="listItems"
      :statusList="[]"
      :statusName="null"
      @sendFilterData="receiveFilterData"
    />
    <div class="align-center d-flex pt-3">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          :items="searchItems"
          item-text="searchText"
          item-value="searchValue"
          v-model="searchCategory"
          solo
          height="30px"
          dense
          class="width100-height30 border-5c5c5c"
          flat
          :menu-props="{ offsetY: true }"
        />
      </div>
      <input
        v-model="searchWord"
        class="cursor-pointer border-5c5c5c back-white width300-height30"
        @keydown.enter="startAndReset(1)"
      />
      <v-btn
        color="#3F557D"
        width="78"
        height="30"
        class="color-white ml-3"
        @click="startAndReset(1)"
      >
        <span class="search-text"> 조회</span>
      </v-btn>
      <v-spacer />
      <StoreModal @resetMethod="startAndReset(1)" v-if="!viewerRole" />
      <div class="pl-2">
        <v-btn
          class="border-btn  align-center justify-center d-flex"
          width="120"
          height="30"
          @click="excelDown"
          :disabled="viewerRole"
        >
          <DownloadIcon :fill="viewerRole ? 'grey' : '#0038FF'" class="mr-1" />
          <span class="border-text ">내려받기</span>
        </v-btn>
      </div>
    </div>
    <div class="pt-5">
      <v-simple-table
        ref="tableRef"
        class="width-100"
        fixed-header
        :height="windowInnerHeight - 48 - 260"
        dense
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-center back-8ca9dd color-white border-right-white cursor-pointer first-child1"
                rowspan="2"
                @click="orderByAlone('orderName')"
                style="width:80px;"
              >
                <div style="width:80px;">
                  발주차수
                  <v-icon color="white">
                    {{
                      orderNameState == "asc"
                        ? "mdi-arrow-up"
                        : "mdi-arrow-down"
                    }}</v-icon
                  >
                </div>
              </th>
              <th
                class="text-center back-8ca9dd color-white  cursor-pointer border-right-white first-child2"
                rowspan="2"
                @click="orderByAlone('partName')"
              >
                <div style="width:230px;">
                  부위<v-icon color="white">
                    {{
                      partState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
                    }}</v-icon
                  >
                </div>
              </th>

              <th
                class="floor-td text-center back-8ca9dd color-white "
                rowspan="2"
              >
                동
              </th>
              <th
                class="floor-td text-center back-8ca9dd color-white border-left-white"
                rowspan="2"
              >
                층
              </th>
              <th
                class="floor-td text-center back-8ca9dd color-white border-left-white  justify-center"
                rowspan="2"
              >
                부재
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white"
                rowspan="1"
                :colspan="materialLength"
              >
                규격(단위:TON)
              </th>
              <th
                class="text-center back-8ca9dd color-white border-left-white border-right-white "
                rowspan="2"
              >
                합계수량
              </th>

              <th
                class="text-center back-8ca9dd color-white border-right-white cursor-pointer word-keep-all"
                rowspan="2"
                @click="orderByAlone('date')"
              >
                <div>
                  입고일자<v-icon color="white">
                    {{
                      dateState == "asc" ? "mdi-arrow-up" : "mdi-arrow-down"
                    }}</v-icon
                  >
                </div>
              </th>

              <th
                class="text-center back-8ca9dd color-white border-right-white "
                rowspan="2"
              >
                <div>
                  송장번호
                </div>
              </th>
              <th class="text-center back-8ca9dd color-white" rowspan="2">
                <div>
                  메모
                </div>
              </th>
            </tr>
            <tr>
              <th
                class="back-8ca9dd color-white text-center border-top-white border-left-white"
                v-for="list in materialList"
                :key="list.rebar_id"
              >
                {{ list.rebar_name }}
              </th>
            </tr>
            <tr v-if="invoiceList.length > 0">
              <th
                colspan="2"
                class="border-left-aaaaaa border-right-aaaaaa text-center border-bottom-aaaaaa back-cadbf9 first-child1"
              >
                총합
              </th>
              <th class="border-right-aaaaaa back-ecf3f9" colspan="3"></th>
              <th
                v-for="(invoiceList, index) in invoiceSumList"
                :key="index"
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa back-ecf3f9"
              >
                {{ invoiceList ? mathRound(invoiceList).toFixed(3) : "0" }}
              </th>
              <th
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa back-ecf3f9"
              >
                {{ sum(invoiceSumList).toFixed(3) }}
              </th>
              <th
                colspan="5"
                class="border-right-aaaaaa border-bottom-aaaaaa back-ecf3f9"
              ></th>
            </tr>
          </thead>
          <tbody v-if="invoiceList.length > 0">
            <tr
              v-for="index in tbodyLength"
              :key="index"
              :class="[invoiceList[index - 1].closeYn === 'Y' ? 'done-tr' : '']"
            >
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa text-center  first-child1"
                :style="{
                  backgroundColor:
                    invoiceList[index - 1].closeYn === 'Y'
                      ? '#fff4f4'
                      : '#f5f5f5',
                }"
              >
                {{ invoiceList[index - 1].orderName }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa  text-center width-200  first-child2"
                :style="{
                  backgroundColor:
                    invoiceList[index - 1].closeYn === 'Y'
                      ? '#fff4f4'
                      : '#f5f5f5',
                }"
              >
                <v-btn
                  @click="
                    $bus.$emit('completeDetail', {
                      completeId: invoiceList[index - 1].completeId,
                      invoiceId: invoiceList[index - 1].invoiceId,
                      partName: invoiceList[index - 1].partName,
                      dong: invoiceList[index - 1].dong,
                      floor: invoiceList[index - 1].floor,
                      invoiceCode: invoiceList[index - 1].invoiceCode,
                      orderName: invoiceList[index - 1].orderName,
                      closeYn: invoiceList[index - 1].closeYn,
                    })
                  "
                  color="#0038FF"
                  text
                  width="230"
                  class="part-btn text-start font-12"
                >
                  {{ invoiceList[index - 1].partName }}
                </v-btn>
              </td>

              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center font-12 px-1"
                style="width:80px;max-width: 120px;"
              >
                {{ invoiceList[index - 1].dong }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center font-12 px-1"
                style="width:80px;max-width: 120px;"
              >
                {{ invoiceList[index - 1].floor }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center font-12 px-1"
                style="width:80px;max-width: 120px;"
              >
                {{ invoiceList[index - 1].type }}
              </td>

              <td
                class="cnt-td border-right-aaaaaa text-right px-1 border-bottom-aaaaaa"
                v-for="i in materialLength"
                :key="i"
              >
                {{
                  invoiceList[index - 1].regacyInvoiceSumList[i - 1]
                    ? mathRound(
                        invoiceList[index - 1].regacyInvoiceSumList[i - 1]
                      ).toFixed(3)
                    : "0"
                }}
              </td>
              <td
                class="border-right-aaaaaa text-right px-1 border-bottom-aaaaaa"
              >
                {{
                  sum(invoiceList[index - 1].regacyInvoiceSumList).toFixed(3)
                }}
              </td>
              <td class="border-right-aaaaaa text-center border-bottom-aaaaaa">
                {{ dateCheck(invoiceList[index - 1].registDate) }}
              </td>

              <td
                class="w-fit border-right-aaaaaa border-bottom-aaaaaa text-center px-1"
              >
                {{ invoiceList[index - 1].invoiceInputCode }}
              </td>
              <td class="border-right-aaaaaa text-center  border-bottom-aaaaaa">
                <v-btn
                  width="100%"
                  @click="
                    memoClick(invoiceList[index - 1].invoiceId, 'complete')
                  "
                  :color="invoiceList[index - 1].memo ? '#0038FF' : '#ff0000'"
                  text
                  :disabled="invoiceList[index - 1].memo ? false : viewerRole"
                >
                  {{ invoiceList[index - 1].memo ? "보기" : "추가" }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="mt-3 justify-center pb-4 mb-4">
      <v-pagination
        v-model="page"
        color="#8EB4FA"
        :length="pageLength"
        v-if="invoiceList.length > 0"
        :total-visible="10"
      ></v-pagination>
    </div>
    <Detail />
  </div>
</template>

<script>
import DatePickerMixin from "@/mixin/DatePicker";
import Search from "@/mixin/Search";
import DatePicker from "@/components/DatePicker";
import FilterModal from "@/components/Filter";
import FileApi from "@/api/FileService";
import Commonality from "@/mixin/Commonality";
import fileDownload from "@/assets/js/file-download";
import CompleteApi from "@/api/CompleteService";
import StoreModal from "./modal/StoreModal";

import Detail from "./StoreDetail";
import DownloadIcon from "@/assets/svgs/DownloadIcon.vue";

export default {
  mixins: [DatePickerMixin, Search, Commonality],

  components: {
    DatePicker,
    Detail,
    StoreModal,
    FilterModal,
    DownloadIcon,
  },

  data: () => ({
    dateItems: ["발주일자"],
    invoiceList: [],
    invoiceTotalList: [],
    invoiceSumList: [],
    tbodyLength: 0,
    dateState: null,
    partState: null,
    orderNameState: "desc",

    filterList: {},
    listItems: [{ searchText: "입고일자", searchValue: 1 }],
    methodFilterData: {},
    windowInnerHeight: 0,
  }),

  created() {
    if (!this.isStoreFilter) {
      this.startAndReset();
    }
    this.$bus.$on("completeNavigationDuplicated", () => {
      this.startAndReset(1);
    });
  },

  beforeDestroy() {
    this.$bus.$off("completeNavigationDuplicated");
  },

  computed: {
    materialLength() {
      return this.materialList.length;
    },
    /** 저장된 필터 있는지 여부 */
    isStoreFilter() {
      return this.$store.getters?.getStoreFilter;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },
  watch: {
    page(val) {
      this.startAndReset(val);
      this.scrollTop();
    },
  },
  methods: {
    /** table Scroll top 이동함수 */
    scrollTop() {
      const container = this.$refs.tableRef?.$el?.querySelector(
        ".v-data-table__wrapper"
      );
      if (container) {
        container.scrollTop = 0;
      }
    },
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    orderByAlone(payload) {
      if (payload == "orderName") {
        this.dateState = null;
        this.partState = null;
        this.orderNameState =
          this.orderNameState && this.orderNameState != "asc" ? "asc" : "desc";
      } else if (payload == "partName") {
        this.orderNameState = null;
        this.dateState = null;
        this.partState =
          this.partState && this.partState != "asc" ? "asc" : "desc";
      } else if (payload == "date") {
        this.orderNameState = null;
        this.partState = null;
        this.dateState =
          this.dateState && this.dateState != "asc" ? "asc" : "desc";
      }

      this.startAndReset();
    },

    async startAndReset(payload) {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        keyword: this.searchWord,
        type: this.searchCategory,
        startDate: this.startDate,
        endDate: this.finishDate,
        currentPage: payload ? payload : this.page,
        pagingCount: 20,
        order: [this.orderNameState, this.partState, this.dateState],
      };
      data = Object.assign(data, this.methodFilterData);
      this.materialLengh = this.materialList.length;
      let result = await CompleteApi.completeTotalList(data);
      this.invoiceTotalList = result.data.completeList;
      this.invoiceList = this.invoiceTotalList;
      //this.orderByAlone(this.invoiceList,"date",false)
      this.pageLength = result.data.pageInfo.endPage;
      this.page = result.data.pageInfo.currentPage;
      this.tbodyLength = result.data.completeList.length;
      this.invoiceSumList = result.data.completeTotalList.totalComplete[0];
      let res = await CompleteApi.completeFilterListSearch(data);
      this.filterList = res.data;
      this.$bus.$emit("loadingEnd");
    },

    async excelDown() {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        keyword: this.searchWord,
        type: this.searchCategory,
        startDate: this.startDate,
        endDate: this.finishDate,
        order: [this.orderNameState, this.partState, this.dateState],
      };
      data = Object.assign(data, this.methodFilterData);
      let res = await FileApi.completeDown(data);
      if (res.data.size > 0) {
        fileDownload(
          res.data,
          `${this.constructionName.constructionName} 입고현황.xlsx`
        );
      } else {
        this.$bus.$emit("dialog", "서버 문제로 잠시후 실행해주세요.");
      }
      this.$bus.$emit("loadingEnd");
    },

    receiveFilterData(data) {
      this.methodFilterData = data;
      this.searchWord = "";
      this.startAndReset(1);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}

.first-child1 {
  position: sticky;
  left: 0;
  z-index: 8 !important;
}
.first-child2 {
  position: sticky;
  left: 81px;
  width: 224px;
  z-index: 8 !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 100%;
}
.font-12 {
  font-size: 12px;
}
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.part-btn {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.width-200 {
  width: 200px;
}

.word-keep-all {
  word-break: keep-all;
}

.back-fb {
  background: #fbfbfb;
  height: 100%;
}

.width100-height30 {
  width: 100px !important;
  height: 30px !important;
}

.width179-height41 {
  width: 179px;
  height: 41px !important;
}

.v-input__control {
  height: 41px !important;
}

.v-text-field {
  height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 38px !important;
  margin: 0px;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #efefef;
}

.v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #efefef;
}
.cnt-td {
  min-width: fit-content !important;
  max-width: 120px;
}
.floor-td {
  min-width: 80px !important;
  max-width: 120px;
}
.w-fit {
  min-width: fit-content !important;
  max-width: 140px !important;
}
@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
.bg-grey {
  background-color: rgba(128, 128, 128, 0.02); /* 회색 배경 */
}
.done-tr {
  > td {
    background-color: #fff4f4;
    // background-color: rgba(255, 64, 64, 0.06) !important;
    // mix-blend-mode: multiply;
  }
}
// .done-tr td {
//   position: relative; /* ✅ td 내부에서 배경 처리 */
// }
// /* 빨간 배경 (위에 덮이는 효과) */
// .done-tr td::before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(255, 64, 64, 0.06); /* 빨간색 투명 */
//   z-index: 1; /* 회색 배경 위에 표시 */
//   pointer-events: none; /* 클릭 이벤트 방지 */
// }
</style>
